import React, { useState, useEffect, useRef } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CardContent,
    Button
} from '@material-ui/core';
import axios from '../../api';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-dt/js/dataTables.dataTables.min.js';
import 'datatables.net/js/jquery.dataTables';
import Swal from "sweetalert2";
import VisualizarDoenca from "../Actions/VisualizarDoenca";
import EditarDoenca from "../Actions/EditarDoenca";
import ExcluirDoenca from "../Actions/ExcluirDoenca";

const columns = [
    { id: 'id', label: 'Código',   width: '5%' },
    { id: 'doenca', label: 'Doença',   width: '20%' },
    { id: 'observacao', label: 'Observações',   width: '20%' },
    { id: 'ativo', label: 'Status Doença',   width: '20%' },
    { id: 'acoes', label: 'Ações',   width: '1%' },
];

function TabelaDoenca() {

    //guarda o estado da tabela
    const [results, setTableData ] = useState([]);
    const tableRef = useRef(null);

    useEffect(() => {
        Swal.fire({
            title: 'Carregando...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        axios.get('/tipodoencas')
            .then(response => {
                const results = response.data.data;
                setTableData(results);

                // Verifique se o DataTable já foi inicializado na tabela
                const table = $('#tipodoencas').DataTable();
                if ($.fn.DataTable.isDataTable('#tipodoencas')) {
                    table.destroy();
                }

                // Inicialize o DataTable aqui
                $(document).ready(function() {
                    $('#tipodoencas').DataTable({
                        language: {
                            url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Portuguese-Brasil.json'
                        },
                        deferRender: true,
                        destroy: true // adicione essa opção
                    });
                });
            })
            .catch(error => {
                console.log(error);
            })
    .finally(() => {
        Swal.close();
        });
    }, [setTableData]);

    function fetchTableData() {
        const token = localStorage.getItem('token');
        axios.get('/tipodoencas', { headers: { Authorization: `Bearer ${token}` } })
            .then(response => {
                const results = response.data.data;
                setTableData(results);
            })
            .catch(error => {
                console.log(error)
            });
    }


    useEffect(() => {
        if (tableRef.current) {
            $(tableRef.current).DataTable();
        }
    }, [results]);


    function AtualizarTabela(id) {
        handleDelete(id)
    }


    //deleta as informações da tabela
    const handleDelete = (id) => {

        axios.delete(`/tipodoencas/${id}`)

            .then((response) => {
                // exibe mensagem de sucesso com cor verde

                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text:  response.data.message,
                });

                setTableData(prevResults => prevResults.filter(result => result.id !== id));
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response.data.error,
                });
            });
    };


    return (
        //class name tabela para deixar sempre com paading
        <TableContainer className={'tabela'} component={Paper}>
            <CardContent>
                <Table id="tipodoencas" ref={tableRef}>
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell id={"header"} key={column.id}  style={{ width: column.width }}>{column.label}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {results.map((result) => (
                            <TableRow key={result.id}>
                                <TableCell>{result.id}</TableCell>
                                <TableCell>{result.doenca}</TableCell>
                                <TableCell>{result.observacao}</TableCell>
                                <TableCell>{(Number(result.ativo) === 1) ? 'Ativo' : 'inativo'}</TableCell>

                                <TableCell>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        margin: '0 auto',

                                    }}>
                                        <VisualizarDoenca
                                            id={Number(result.id)}
                                            title="Detalhes"
                                            apiUrl={`https://gerenciamentoatendimento.cloud/api/tipodoencas/show/`}
                                        />
                                        <EditarDoenca
                                            id={Number(result.id)}
                                            title="Editar"
                                            apiUrl={`https://gerenciamentoatendimento.cloud/api/tipodoencas/show/`}
                                            fetchTableData={fetchTableData}
                                        />
                                        <ExcluirDoenca
                                            id={Number(result.id)}
                                            title="Excluir"
                                            apiUrl={`https://gerenciamentoatendimento.cloud/api/tipodoencas/`}
                                            AtualizarTabela={AtualizarTabela}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>

                </Table>
            </CardContent>
        </TableContainer>

    );
}

export default TabelaDoenca;
